import { render, staticRenderFns } from "./lgformulario.vue?vue&type=template&id=0a057d82&"
import script from "./lgformulario.vue?vue&type=script&lang=js&"
export * from "./lgformulario.vue?vue&type=script&lang=js&"
import style0 from "./lgformulario.vue?vue&type=style&index=0&id=0a057d82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports